export default function initReferentNotes() {
  if (window.__enableReferentNotesInit) return; // avoid double init
  window.__enableReferentNotesInit = true;

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getAjaxUrl() {
    if (window.enable && window.enable.ajax_url) return window.enable.ajax_url;
    if (typeof window.ajaxurl !== "undefined") return window.ajaxurl; // admin fallback
    var dataAttr = document.body
      ? document.body.getAttribute("data-ajax-url")
      : "";
    if (dataAttr) return dataAttr;
    return "/wp-admin/admin-ajax.php";
  }

  document.addEventListener("click", function (e) {
    // Edit
    var editBtn =
      e.target &&
      (e.target.classList && e.target.classList.contains("edit-notes")
        ? e.target
        : e.target.closest
        ? e.target.closest(".edit-notes")
        : null);
    if (editBtn) {
      var cell = closest(editBtn, ".referent-notes-cell");
      if (!cell) return;
      var view = cell.querySelector(".notes-view");
      var edit = cell.querySelector(".notes-edit");
      if (view && edit) {
        view.classList.add("d-none");
        edit.classList.remove("d-none");
      }
      return;
    }

    // Cancel
    var cancelBtn =
      e.target &&
      (e.target.classList && e.target.classList.contains("cancel-notes")
        ? e.target
        : e.target.closest
        ? e.target.closest(".cancel-notes")
        : null);
    if (cancelBtn) {
      var cellC = closest(cancelBtn, ".referent-notes-cell");
      if (!cellC) return;
      var viewC = cellC.querySelector(".notes-view");
      var editC = cellC.querySelector(".notes-edit");
      if (viewC && editC) {
        editC.classList.add("d-none");
        viewC.classList.remove("d-none");
      }
      return;
    }

    // Save
    var saveBtn =
      e.target &&
      (e.target.classList && e.target.classList.contains("save-notes")
        ? e.target
        : e.target.closest
        ? e.target.closest(".save-notes")
        : null);
    if (saveBtn) {
      var cellS = closest(saveBtn, ".referent-notes-cell");
      if (!cellS) return;
      var deviceId = cellS.getAttribute("data-device-id");
      var nonce = cellS.getAttribute("data-nonce");
      var textarea = cellS.querySelector(".notes-textarea");
      var notes = textarea ? textarea.value : "";
      saveBtn.disabled = true;
      fetch(getAjaxUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: new URLSearchParams({
          action: "update_referent_notes",
          device_id: deviceId,
          notes: notes,
          _wpnonce: nonce,
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (json) {
          saveBtn.disabled = false;
          if (json && json.success) {
            var txt = cellS.querySelector(".notes-text");
            if (txt)
              txt.innerHTML = notes
                ? notes.replace(/\n/g, "<br>")
                : window.enable && window.enable.i18n_no_notes
                ? window.enable.i18n_no_notes
                : "(aucune note)";
            var viewS = cellS.querySelector(".notes-view");
            var editS = cellS.querySelector(".notes-edit");
            if (viewS && editS) {
              editS.classList.add("d-none");
              viewS.classList.remove("d-none");
            }
          } else {
            var msg =
              json && json.data && json.data.message
                ? json.data.message
                : "Erreur";
            // eslint-disable-next-line no-alert
            alert(msg);
          }
        })
        .catch(function () {
          saveBtn.disabled = false;
          // eslint-disable-next-line no-alert
          alert("Erreur réseau");
        });
      return;
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/util/referentNotes.js